import configuration from './configuration.json'

export default {
    get(path, value) {
        return path.split('.').reduce(
            (scope, segment) => typeof scope === 'object' && segment in scope 
                ? scope[segment] : value,
            configuration
        )
    },
    has(path) {
        return path.split('.').reduce(
            (scope, segment) => typeof scope === 'object' && segment in scope 
                ? scope[segment] : undefined,
            configuration
        ) !== undefined
    }
}